<template>
  <div class="assignment-status" :class="getStatusClass(assignment)">
    <IconComponent class="assignment-status__icon" :name="getStatusClassIcon(assignment)" />
    <span class="assignment-status__text">
      {{ assignment.statusName }}
    </span>
  </div>
</template>

<script>
  import IconComponent from '@/common/ui/IconComponent.vue';

  import { getStatusClass, getStatusClassIcon } from '../utils/statusClass';

  export default {
    name: 'AssignmentStatus',

    components: {
      IconComponent,
    },

    props: {
      assignment: {
        type: Object,
        required: true,
      },
    },

    methods: {
      getStatusClassIcon(assignment) {
        return getStatusClassIcon(assignment);
      },

      getStatusClass(assignment) {
        return getStatusClass(assignment);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .assignment-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    text-align: center;

    &.status {
      &-done {
        color: #24c20f;
      }
      &-close {
        color: #f04f4f;
      }
      &-late {
        color: #f04f4f;
      }
      &-inWork {
        color: #ffa800;
      }
    }
  }

  .assignment-status__icon {
  }

  .assignment-status__text {
  }
</style>
